// A second, independent way to notice a new deploy. Every build writes /version.json containing its own build id.
// The app compares that to the id baked into the running code; if they differ, it clears the offline caches and reloads.
// This works even when a host or CDN has cached sw.js and the browser never notices a new service worker.
// Your data is untouched: only the app's cached files (Cache Storage and the service worker) are cleared.
export const BUILD_ID = typeof __BUILD_ID__ !== "undefined" ? __BUILD_ID__ : "dev";

// What the last check found, for the Settings screen to show.
export let lastCheck = null;

// Cloudflare Pages gives every upload its own address like https://1a2b3c4d.myapp.pages.dev. That copy is frozen: it never
// changes, so an app opened or installed from it can never update. The main address (https://myapp.pages.dev) always serves
// the newest production deployment.
export function deploymentLinkHost() {
  try { const h = window.location.hostname; return /^[0-9a-f]{6,12}\.[a-z0-9-]+\.pages\.dev$/i.test(h) ? h : ""; } catch (e) { return ""; }
}
export const mainAddressFor = (host) => host.split(".").slice(1).join(".");

async function latestBuild() {
  const r = await fetch(`/version.json?t=${Date.now()}`, { cache: "no-store" });
  if (!r.ok) throw new Error("no version file");
  const j = await r.json();
  const latest = j && j.build ? String(j.build) : null;
  lastCheck = { running: BUILD_ID, latest, host: window.location.host, cache: r.headers.get("cf-cache-status") || "", at: new Date() };
  return latest;
}

export async function hardRefresh() {
  try {
    const regs = (await navigator.serviceWorker?.getRegistrations?.()) || [];
    await Promise.all(regs.map((r) => r.unregister()));
    const keys = (await window.caches?.keys?.()) || [];
    await Promise.all(keys.map((k) => window.caches.delete(k)));
  } catch (e) { /* reload anyway */ }
  window.location.reload();
}

// Returns "updating" (a reload has started), "current", or "unknown" (couldn't tell, e.g. offline or running locally).
export async function checkForNewBuild({ manual = false } = {}) {
  try {
    const latest = await latestBuild();
    if (!latest || BUILD_ID === "dev") return "unknown";
    if (latest === BUILD_ID) return "current";
    // guard against a reload loop if the host keeps serving the old files
    let tried = null;
    try { tried = sessionStorage.getItem("bb-refresh-for"); } catch (e) { /* ignore */ }
    if (!manual && tried === latest) return "unknown";
    try { sessionStorage.setItem("bb-refresh-for", latest); } catch (e) { /* ignore */ }
    await hardRefresh();
    return "updating";
  } catch (e) { return "unknown"; }
}
